export const LOAD_CONFERENCE_PARTICIPANTS = 'LOAD_CONFERENCE_PARTICIPANTS';
export const LOAD_CONFERENCE_PARTICIPANTS_SUCCESS = `${LOAD_CONFERENCE_PARTICIPANTS}_SUCCESS`;
export const LOAD_CONFERENCE_PARTICIPANTS_FAIL = `${LOAD_CONFERENCE_PARTICIPANTS}_FAIL`;

export const LOAD_EVENTS = 'LOAD_EVENTS';
export const LOAD_EVENTS_SUCCESS = `${LOAD_EVENTS}_SUCCESS`;
export const LOAD_EVENTS_FAIL = `${LOAD_EVENTS}_FAIL`;

export const SORT_CONFERENCE_EVENTS = 'SORT_CONFERENCE_EVENTS';
export const SORT_CONFERENCE_EVENTS_SUCCESS = `${SORT_CONFERENCE_EVENTS}_SUCCESS`;
export const SORT_CONFERENCE_EVENTS_FAIL = `${SORT_CONFERENCE_EVENTS}_FAIL`;

export const SET_SPEAKING_LIST = 'SET_SPEAKING_LIST';

export function loadConferenceParticipants(conferenceId) {
  return {
    type: LOAD_CONFERENCE_PARTICIPANTS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/conferences/${conferenceId}/participants`,
      method: 'get',
    },
  };
}

export function loadConferenceEvents(conferenceId) {
  return {
    type: LOAD_EVENTS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/events?conferenceId=${conferenceId}`,
      method: 'get',
    },
  };
}

export function sortConferenceEvents(conferenceId, sortBy, sortOrder) {
  return {
    type: SORT_CONFERENCE_EVENTS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/events?conferenceId=${conferenceId}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      method: 'get',
    },
  };
}
